import { createSlice } from '@reduxjs/toolkit'
import { AuthState } from '../../types/keycloak'
import { initializeKeycloak } from './login'
import { registerUser } from './register'

const initialState: AuthState = {
  keycloak: null,
  authenticated: localStorage.getItem('authenticated') === 'true' || false,
  username: localStorage.getItem('username') || null,
  token: localStorage.getItem('token') || null,
  loading: false,
  error: null,
  roles: JSON.parse(localStorage.getItem('roles') || '[]'),
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state) => {
      state.authenticated = false
      state.username = null
      state.token = null
      state.roles = []
      localStorage.removeItem('token')
      localStorage.removeItem('username')
      localStorage.removeItem('authenticated')
      localStorage.removeItem('roles')
      localStorage.removeItem('selectedNorm')
      localStorage.removeItem('tenantClientId')
    },
    updateRoles: (state, action) => {
      state.roles = action.payload
      localStorage.setItem('roles', JSON.stringify(action.payload))
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(initializeKeycloak.pending, (state) => {
        state.loading = true
      })
      .addCase(initializeKeycloak.fulfilled, (state, action) => {
        state.loading = false
        state.authenticated = true
        state.username = action.payload.keycloak.username
        state.token = action.payload.token
        state.roles = action.payload.roles
        localStorage.setItem('authenticated', 'true')
        localStorage.setItem('token', action.payload.token)
        localStorage.setItem('username', action.payload.keycloak.username)
        localStorage.setItem('roles', JSON.stringify(action.payload.roles))
      })
      .addCase(initializeKeycloak.rejected, (state, action) => {
        state.loading = false
        state.error =
          (action.payload as string) || action.error.message || 'Login failed'
      })
      .addCase(registerUser.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        state.loading = false
        state.authenticated = true
        state.username = action.payload.username
        state.token = action.payload.token
        localStorage.setItem('authenticated', 'true')
        localStorage.setItem('token', action.payload.token)
        localStorage.setItem('username', action.payload.username)
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.loading = false
        console.log('action error message', action.error.message)
        console.log('action payload', action.payload)

        state.error =
          (action.payload as string) ||
          action.error.message ||
          'Registration failed'
      })
  },
})

export const { logout, updateRoles } = authSlice.actions
export default authSlice.reducer
